import { api } from "@/lib/api";

// §102 Turn a sourced candidate into an anonymized MPC.
export const addMpc = (c, projectId) => api.post("/admin/rcc/mpcs/from-candidate", { candidate_id: c.candidate_id || c.id, source: "si_candidate", project_id: projectId }).then((r) => r.data);
